import { useQuery } from '@tanstack/react-query'

import { get } from 'utils/http'

const getWorkflow = (workflowId: any) => get(`/management/workflows/${workflowId}`)

export const useWorkflow = (workflowId: any) => {
  return useQuery({
    queryKey: ['workflows', workflowId],
    queryFn: () => getWorkflow(workflowId),
    enabled: !!workflowId,
    staleTime: 60 * 60 * 1000,
  })
}
